/**
 * Cost Floating Legend — Shows cost visualization color scales
 */
import { X } from 'lucide-react';

const LEGENDS = {
  BUDGET_VS_ACTUAL: {
    title: 'Budget vs Actual',
    items: [
      { color: '#22C55E', label: 'Deep Under Budget (<25%)' },
      { color: '#4ADE80', label: 'Under Budget (25-35%)' },
      { color: '#84CC16', label: 'Moderate (35-45%)' },
      { color: '#A3E635', label: 'Approaching (45-55%)' },
      { color: '#FACC15', label: 'Near Budget (55-70%)' },
      { color: '#F59E0B', label: 'Close to Budget (70-85%)' },
      { color: '#FB923C', label: 'At Budget (85-100%)' },
      { color: '#F97316', label: 'Slightly Over (100-115%)' },
      { color: '#EF4444', label: 'Over Budget (>115%)' },
      { color: '#6B7280', label: 'No Data' },
    ],
  },
  COST_DISTRIBUTION: {
    title: 'Cost Distribution (vs Max)',
    items: [
      { color: '#EFF6FF', label: 'Minimal (<5% of max)' },
      { color: '#DBEAFE', label: 'Low (5-15%)' },
      { color: '#93C5FD', label: 'Medium-Low (15-30%)' },
      { color: '#60A5FA', label: 'Medium (30-50%)' },
      { color: '#3B82F6', label: 'High (50-75%)' },
      { color: '#1E3A8A', label: 'Highest (>75%)' },
    ],
  },
  EVM_OBJECTS: {
    title: 'EVM Performance (CPI)',
    items: [
      { color: '#166534', label: 'Outstanding CPI (>4.0)' },
      { color: '#22C55E', label: 'Excellent CPI (3.0-4.0)' },
      { color: '#4ADE80', label: 'Very Good CPI (2.5-3.0)' },
      { color: '#84CC16', label: 'Good CPI (2.0-2.5)' },
      { color: '#FACC15', label: 'Moderate CPI (1.5-2.0)' },
      { color: '#F59E0B', label: 'Low CPI (1.0-1.5)' },
      { color: '#F97316', label: 'Warning CPI (0.85-1.0)' },
      { color: '#EF4444', label: 'Critical CPI (<0.85)' },
      { color: '#6B7280', label: 'No Data' },
    ],
  },
  COST_TIMELINE: {
    title: 'Cost Timeline',
    items: [
      { color: '#22C55E', label: 'Under Budget' },
      { color: '#F59E0B', label: 'On Budget' },
      { color: '#EF4444', label: 'Over Budget' },
      { color: '#6B7280', label: 'Not Yet Incurred' },
    ],
  },
};

export function CostLegend({ mode, visible, onToggle }) {
  if (!visible) return null;
  const legend = LEGENDS[mode] || LEGENDS.BUDGET_VS_ACTUAL;

  return (
    <div className="absolute bottom-3 left-3 z-20 bg-background/90 backdrop-blur-md border rounded-lg p-3 min-w-[180px] shadow-lg" data-testid="cost-legend">
      <div className="flex items-center justify-between mb-2">
        <span className="text-xs font-semibold">{legend.title}</span>
        <button onClick={onToggle} className="text-muted-foreground hover:text-foreground">
          <X className="w-3.5 h-3.5" />
        </button>
      </div>
      <div className="space-y-1">
        {legend.items.map((item, i) => (
          <div key={i} className="flex items-center gap-2">
            <div className="w-4 h-3 rounded-sm" style={{ backgroundColor: item.color }} />
            <span className="text-[10px] text-muted-foreground">{item.label}</span>
          </div>
        ))}
      </div>
    </div>
  );
}
